import { LudsToast } from '../design-system/toast/toast';
import { LudsToastStack } from '../design-system/toast/toast-stack';

export class ToastService {
  private static instance: ToastService;

  private stackEl: LudsToastStack | null = null;

  async showToast(options: Partial<LudsToast> = {}): Promise<number> {
    await import('../design-system/toast/toast-stack');

    if (!this.stackEl) {
      this.stackEl = document.createElement('luds-toast-stack');

      document.body.appendChild(this.stackEl);
    }

    return this.stackEl.addToast(options);
  }

  dismissToast(index: number): void {
    this.stackEl.removeToast(index);
  }

  public static getInstance() {
    if (!ToastService.instance) {
      ToastService.instance = new ToastService();
    }

    return ToastService.instance;
  }
}
